import script from "./password-input.vue?vue&type=script&lang=ts&setup=true"
export * from "./password-input.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__